export default __webpack_public_path__ + "static/media/kushagra-circle-icon.280a36b2.png";